<template>
    <div>
      <a href="baseUrl" class=" ">
      <img  class="img-fluid img-width"   alt="Aruvaa Logo" src="\imgs\aruvaa_logo.png"/>
      </a>
    </div>
</template>
<style scoped>

.img-width{
width: 35%;
}

</style>

<script>

export default{
  data() {
    return {
      baseUrl: this.$utils.goToUrl(window.env.baseTenantUrl),
    }
  },
}
</script>